import type { FC } from "react";

import { cn } from "@/ui/lib";
import { TEXTAREA_DEFAULTS, TTextareaProps } from "./Textarea.config";
import { TextareaField } from "./TextareaField";
import { Field } from "../Field";
import { Label } from "../Label";
import { Grid } from "../../layout/Grid";
import { Column } from "../../layout/Column";

export const Textarea: FC<TTextareaProps> = (
  {
    label,
    rows = TEXTAREA_DEFAULTS.rows,
    disabled,
    value,
    className,
    error,
    ...props
  },
) => {

  return (
    <Field
      data-component="Textarea"
      className={cn(
        "cursor-pointer grid gap-x-2",
        disabled && "cursor-not-allowed",
        className,
      )}
    >
      <Grid gap="3">
        <Column>
          <Label
            className={cn(
              "peer-disabled:opacity-70",
            )}
          >{ label }</Label>
        </Column>
        <Column>
          <TextareaField
            {...props}
            rows={rows}
            value={value}
            disabled={disabled}
            error={error}
          />
        </Column>
      </Grid>
    </Field>
  );
};

Textarea.displayName = "Textarea";
